module.exports = __webpack_public_path__ + "static/img/wxCode.7b7fc36.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile_images/wxCode.jpg
// module id = pk1F
// module chunks = 1